import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ButtonDropdown, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Table } from 'reactstrap';
import { Trans } from 'react-i18next';
import { Page, FormGroup } from 'components/common';
import BackButton from 'components/refactoring/BackButton';
import { Control, LocalForm } from 'react-redux-form';
import { useOrganisationContext, useUserContext } from "hooks";
import { ApiClient, } from "services";
import { NotificationManager } from "react-notifications";

const RegisteredAssetDetail = ({ onSave, onCancel, t, history, match }) => {
    const [toggle, setToggle] = useState(false);
    const [assetDetail, setAssetDetail] = useState(null);
    const [accounts, setAssetAccounts] = useState([]);
    const [assetTypes, setAssetTypes] = useState([]);

    const { selectedOrganisation } = useOrganisationContext();
    const client = ApiClient();

    const connectedOrg = selectedOrganisation?.id;
    const asset_id = match.params.id;



    useEffect(() => {

        if (asset_id && connectedOrg) {
            fetchRegisteredAssetDetail();
            fetchAssetAccounts();
            fetchAssetTypes();
        }
    }, [asset_id, connectedOrg]);

    const fetchRegisteredAssetDetail = async () => {
        try {
            const response = await client.get(`/fixed-assets/${connectedOrg}/assets/${asset_id}`);
            if (response && response.data) {
                setAssetDetail(response.data);
            } else {
                console.log("");
            }
        } catch (error) {
            NotificationManager.error(t("Something went wrong!"));
            console.error(error);
        }
    };

    const fetchAssetAccounts = async () => {
        try {
            const response = await client.get(`/xero/${connectedOrg}/accounts`);
            setAssetAccounts(response.data);
        } catch (error) {
            NotificationManager.error(t("Error fetching asset accounts"));
            console.error(error);
        }
    };

    const fetchAssetTypes = async () => {
        try {
            const response = await client.get(`/asset-types/${connectedOrg}/assettypes`);
            setAssetTypes(response.data);
        } catch (error) {
            NotificationManager.error(t("Error fetching asset types"));
            console.error(error);
        }
    };

    const getAssetTypeName = () => {
        const assetType = assetTypes.find(type => type.assetTypeId === assetDetail?.assetTypeId);
        return assetType ? assetType.assetTypeName : '';
    };
    const findAccountById = (accountId) => {
        const account = accounts.find(account => account?.AccountID === accountId);
        return account ? account : { Name: '', Code: '' };
    };

    const getAccountNamesAndCodes = (assetTypeId) => {
        const assetType = assetTypes.find(type => type?.assetTypeId === assetTypeId);

        if (!assetType) {
            return {
                accumulatedDepreciationName: '',
                accumulatedDepreciationCode: '',
                depreciationExpenseName: '',
                depreciationExpenseCode: '',
                fixedAssetName: '',
                fixedAssetCode: ''
            };
        }

        const accumulatedDepreciationAccount = findAccountById(assetType?.accumulatedDepreciationAccountId);
        const depreciationExpenseAccount = findAccountById(assetType?.depreciationExpenseAccountId);
        const fixedAssetAccount = findAccountById(assetType?.fixedAssetAccountId);

        return {
            accumulatedDepreciationName: accumulatedDepreciationAccount?.Name,
            accumulatedDepreciationCode: accumulatedDepreciationAccount?.Code,
            depreciationExpenseName: depreciationExpenseAccount?.Name,
            depreciationExpenseCode: depreciationExpenseAccount?.Code,
            fixedAssetName: fixedAssetAccount?.Name,
            fixedAssetCode: fixedAssetAccount?.Code
        };
    };

    const {
        accumulatedDepreciationName,
        accumulatedDepreciationCode,
        depreciationExpenseName,
        depreciationExpenseCode,
        fixedAssetName,
        fixedAssetCode
    } = getAccountNamesAndCodes(assetDetail?.assetTypeId);


    function handleButtonClick(url) {
        window.open(url, '_blank');
    }

    const handleEditClick = () => {
        if (assetDetail?.assetId) {
            history.push(`/fixed-assets/edit/${assetDetail.assetId}`);
        }
    };

    return (
        <Page title={t("Asset Details")}>
            <Row>
                <Col md={10}>
                    <BackButton />
                </Col>
                <Col md={2} className='text-right'>
                    {assetDetail?.assetStatus === "Disposed" ? (
                        <>
                            <Button
                                color='primary'
                                onClick={() => handleButtonClick(`https://fixedassets.xero.com/?#asset/${assetDetail?.assetId}`)}
                            >
                                <Trans>Undo Disposal</Trans>
                            </Button>
                        </>

                    ) :
                        <ButtonDropdown toggle={() => setToggle(!toggle)}>
                            <Dropdown isOpen={toggle} toggle={() => setToggle(!toggle)} direction={"down"}>
                                <DropdownToggle caret className="btn btn-success" style={{ boxShadow: "none" }}><Trans>Options</Trans></DropdownToggle>
                                <DropdownMenu >
                                    <DropdownItem onClick={handleEditClick}>
                                        <Trans>Edit</Trans>
                                    </DropdownItem>
                                    <DropdownItem onClick={() => handleButtonClick(`https://fixedassets.xero.com/?#asset/${assetDetail?.assetId}`)}><Trans>Dispose</Trans></DropdownItem>
                                    <DropdownItem onClick={() => handleButtonClick(`https://fixedassets.xero.com/?#asset/${assetDetail?.assetId}`)}><Trans>Delete</Trans></DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </ButtonDropdown>
                    }
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <label><strong><Trans>Asset Name</Trans></strong></label>
                        <div>
                            {assetDetail?.assetName} {assetDetail?.assetStatus === "Disposed" && <Button color='danger'><Trans>Disposed</Trans></Button>}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <label><strong><Trans>Asset Number</Trans></strong></label>
                        <div>
                            {assetDetail?.assetNumber}
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <hr></hr>
            <Row>
                <Col md={2}>
                    <FormGroup>
                        <label><strong><Trans>Purchase Date</Trans></strong></label>
                        <div>
                            {assetDetail?.purchaseDate}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <label><strong><Trans>Purchase Price</Trans></strong></label>
                        <div>
                            {assetDetail?.purchasePrice}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <label><strong><Trans>Warranty Expiry</Trans></strong></label>
                        <div>
                            {assetDetail?.warrantyExpiryDate ? assetDetail?.warrantyExpiryDate : "-"}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <label><strong><Trans>Serial Number</Trans></strong></label>
                        <div>
                            {assetDetail?.serialNumber ? assetDetail?.serialNumber : "-"}
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <label><strong><Trans>Asset Type</Trans></strong></label>
                        <div>
                            {getAssetTypeName()}
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={2}>
                    <FormGroup>
                        <label><strong><Trans>Asset Account</Trans></strong></label>
                        <div>
                            {fixedAssetCode} - {fixedAssetName}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <label><strong><Trans>Accumulated Depreciation Account</Trans></strong></label>
                        <div>
                            {accumulatedDepreciationCode} - {accumulatedDepreciationName}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <label><strong><Trans>Depreciation Expense Account</Trans></strong></label>
                        <div>
                            {depreciationExpenseCode} - {depreciationExpenseName}
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={12}>
                    <FormGroup>
                        <label><strong><Trans>Description</Trans></strong></label>
                        <div>
                            {assetDetail?.description}
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <hr className='mt-4' />
            <Row>
                <Col md={12}>
                    <h3><Trans>Book Value</Trans></h3>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={12}>
                    <FormGroup>
                        <label><strong><Trans>Depreciation Start Date</Trans></strong></label>
                        <div>
                            {assetDetail?.bookDepreciationDetail?.depreciationStartDate}
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <label><strong><Trans>Depreciation Method</Trans></strong></label>
                        <div>
                            {assetDetail?.bookDepreciationSetting?.depreciationMethod}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <label><strong><Trans>Averaging Method</Trans></strong></label>
                        <div>
                            {assetDetail?.bookDepreciationSetting?.averagingMethod}
                        </div>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <label><strong><Trans>{assetDetail?.bookDepreciationSetting?.depreciationRate ? t('Rate') : t('Effective life')}</Trans></strong></label>
                        <div>
                            {assetDetail?.bookDepreciationSetting?.depreciationRate || assetDetail?.bookDepreciationSetting?.effectiveLifeYears}
                        </div>
                    </FormGroup>
                </Col>
            </Row>



        </Page>
    );
};

export default RegisteredAssetDetail;
